import { render } from "./GestaoProducaoKpis.vue?vue&type=template&id=7bd9b726&scoped=true"
import script from "./GestaoProducaoKpis.vue?vue&type=script&lang=js"
export * from "./GestaoProducaoKpis.vue?vue&type=script&lang=js"

import "./GestaoProducaoKpis.vue?vue&type=style&index=0&id=7bd9b726&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bd9b726"]])

export default __exports__